import { SendMessageCommand, SQSClient } from "@aws-sdk/client-sqs";
import { Auth } from "aws-amplify";
import config from "../config";
import { getCurrentDate } from "./utils";

const configObj = config.getConfigObject();

export async function placeEvent(stepName, email, payload) {
  try {
    let credentials = await Auth.currentCredentials();
    const currentDate = getCurrentDate(false);
    const client = new SQSClient({
      region: "us-west-2",
      credentials
    });
    const params = {
      QueueUrl: configObj.sqs.URL,
      MessageBody: Buffer.from(JSON.stringify({ stepName, email, payload, currentDate })),
    };
    const command = new SendMessageCommand(params);
    return client.send(command);
  } catch (e) {
    return true;
  }

}
